
document.addEventListener('recommendations:loaded', function(evt) {
    const relatedProducts = document.querySelectorAll('input.pbk-related--item');

    // Skip if no related products
    if (relatedProducts.length === 0 || evt.detail.intent !== "complementary") {
        return;
    }

    let pbkHandlingCart = false;

    const addToCart = async (items, selectedCheckBoxes) => {
        try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items }),
            });

            if (!response.ok) {
                throw new Error('Failed to add items to cart');
            }

            const data = await response.json();
            selectedCheckBoxes.forEach(box => box.checked = false);
            return data;
        } catch (error) {
            console.error('Error adding products to cart:', error);
            throw error;
        }
    };

    const getCurrentProductId = () => {
        const productSelect = document.querySelector('select[name="id"][data-product-select]');
        return productSelect?.options[productSelect.selectedIndex]?.value || null;
    };

    const getSelectedRelatedItems = () => {
        return Array.from(document.querySelectorAll('input.pbk-related--item:checked'))
            .map(checkbox => ({ id: checkbox.dataset.pbkvarid, quantity: 1 }));
    };

    const handleDrawerModeSubmit = async (event) => {
        event.preventDefault();
        pbkHandlingCart = true;

        const relatedItems = getSelectedRelatedItems();
        const currentProductId = getCurrentProductId();
        const allItems = currentProductId ? [{ id: currentProductId, quantity: 1 }, ...relatedItems] : relatedItems;

        if (allItems.length > 0) {
            try {
                await addToCart(allItems, document.querySelectorAll('input.pbk-related--item:checked'));
                document.dispatchEvent(new CustomEvent('cart:build'));
            } catch (error) {
                console.error('Error in drawer mode:', error);
            }
        }
        pbkHandlingCart = false;
    };

    const handleCartPageModeAdded = async (event) => {
        if (pbkHandlingCart) return;

        pbkHandlingCart = true;
        const relatedItems = getSelectedRelatedItems();

        if (relatedItems.length > 0) {
            try {
                await addToCart(relatedItems, document.querySelectorAll('input.pbk-related--item:checked'));

                if (document.body.classList.contains('template-cart')) {
                    window.scrollTo(0, 0);
                    location.reload();
                } else {
                    window.location = theme.routes.cartPage;
                }
            } catch (error) {
                console.error('Error in cart page mode:', error);
                pbkHandlingCart = false;
            }
        } else {
            pbkHandlingCart = false;
        }
    };

    const productForm = document.querySelector('form[action="/cart/add"]');
    if (productForm) {
        if (theme.settings.cartType === 'drawer') {
            productForm.addEventListener('submit', handleDrawerModeSubmit);
        } else {
            productForm.addEventListener('ajaxProduct:added', handleCartPageModeAdded);
        }
        productForm.dataset.pbkRelatedActive = 'true';
    }
});